
<a-layout-sider class="sider" width="273">
  <setting-item title="导航栏颜色">
    <img-checkbox-group @change="setTheme">
      <img-checkbox img="static/img/side-bar-dark.svg" :checked="dark"
                    value="dark"/>
      <img-checkbox img="static/img/side-bar-light.svg" :checked="!dark"
                    value="light"/>
    </img-checkbox-group>
  </setting-item>
  <setting-item title="主题颜色">
    <color-checkbox-group @change="onColorChange" :defaultValues="defaultValues" :multiple="false">
      <template v-for="(color, index) in colorList">
        <color-checkbox :color="color" :value="index + 1" :key="index"/>
      </template>
    </color-checkbox-group>
  </setting-item>
  <a-divider/>
  <setting-item title="导航栏位置">
    <img-checkbox-group @change="setLayout">
      <img-checkbox img="static/img/side-bar-left.svg" :checked="side" value="side"/>
      <img-checkbox img="static/img/side-bar-top.svg" :checked="!side" value="head"/>
    </img-checkbox-group>
  </setting-item>
  <setting-item>
    <a-list :split="false">
      <a-list-item>
        固定顶栏
        <a-switch :checked="fixedHeader" slot="actions" size="small" @change="fixHeader"/>
      </a-list-item>
      <a-list-item>
        固定侧边栏
        <a-switch :checked="fixedSiderbar" slot="actions" size="small" @change="fixSiderbar"/>
      </a-list-item>
      <a-list-item>
        多页签模式
        <a-switch :checked="multipage" slot="actions" size="small" @change="setMultipage"/>
      </a-list-item>
    </a-list>
  </setting-item>
  <a-button style="width: 100%" icon="save" :loading="saving" @click="updateUserConfig">保存设置</a-button>
</a-layout-sider>
